import { render } from "./ServiciosEng.vue?vue&type=template&id=64998a94"
import script from "./ServiciosEng.vue?vue&type=script&lang=js"
export * from "./ServiciosEng.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__